import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { pure } from '@dbk/ui-react-utils';
import { DATE_FORMATS } from '../../../constants';

function DisplayTime(props) {
    const { dateAndTime } = props;
    let displayTime = moment(new Date().toISOString()).format(DATE_FORMATS.displayChatDateAndTime);

    if (dateAndTime) {
        if (dateAndTime.duration) {
            if (dateAndTime.createDateTime) {
                displayTime = moment(dateAndTime.createDateTime).format(DATE_FORMATS.displayChatDateAndTime);
            }
        }

    }
    return displayTime;
}


DisplayTime.propTypes = {
    dateAndTime: PropTypes.object,
    messages: PropTypes.object
};

export default pure(DisplayTime);

